import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

import createSelfSourcedLearnerMutation from "../graph-ql/CreateSelfSourcedLearner.graphql";

const useMutationCreateSelfSourcedLearner = ({
  onCompleted,
  onError,
}: MutationHookOptions) =>
  useMutation(createSelfSourcedLearnerMutation, {
    onCompleted,
    onError,
  });

export default useMutationCreateSelfSourcedLearner;
